import React, {Component} from 'react';
import Modal from 'react-responsive-modal';
import PropTypes from 'prop-types';
import {Alert, Button} from 'tabler-react';
import fetch from '../../support/fetch';

const propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    plan: PropTypes.object,
    couponCode: PropTypes.string,
};

const monthName = {
    month: 'mensal',
    year: 'anual'
};

class SelectedPlan extends Component {
    state = {
        open: this.props.open,
        creating: false,
        feedbackText: '',
        feedbackColor: 'danger',
        couponObj: null,
        discount: 0.00,
        hasActiveSubscription: false,
        toBeCancelledId: null
    };

    checkExistingSubscriptions = () => {
        fetch.obj({
            query: `query FetchAllSubscriptions{
                subscriptions{
                    data {
                        id
                        status
                    }
                }
            }`,
            variables: {}
        })
        .then(res => {
            const subscriptions = res.data.subscriptions.data;
            let hasActiveSubscription = false;
            let toBeCancelledId = null;

            Object.keys(subscriptions).forEach((el, i) => {
                if (subscriptions[el].status === 'ACTIVATED') {
                    hasActiveSubscription = true;
                    toBeCancelledId = subscriptions[el].id;
                }
            });
            this.setState({
                hasActiveSubscription: hasActiveSubscription,
                toBeCancelledId: toBeCancelledId
            })
        });
    }

    modalOnCloseHandler = () => {
        this.setState({feedbackText: ''});
        !this.state.creating && this.props.onClose(false);
    };

    componentDidUpdate = (prevProps, prevState) => {
        if (this.props.open !== prevProps.open) {
            this.setState({
                open: this.props.open
            }, () => {
                this.fetchCouponInfo();
                this.checkExistingSubscriptions();
            });
        }
    };

    fetchCouponInfo = () => {
        if (!this.props.couponCode) {
            return;
        }

        fetch.obj({
            query: `query FindCouponByCode($coupon_code: String!) {
                findCouponByCode(code: $coupon_code) {
                    name,
                    name,
                    code,
                    description,
                    discount
                }
            }`,
            variables: {
                coupon_code: this.props.couponCode
            }
        })
        .then(res => {
            const coupon = res.data.findCouponByCode;

            if (coupon) {
                this.setState({
                    couponObj: coupon,
                    discount: coupon.discount
                });
            }
        });
    };

    closeModal = () => {
        this.modalOnCloseHandler();
    };

    createNEwSubscription = () => {
        fetch.obj({
            query: `mutation CreateNewSubscription($plan_id: ID!, $coupon_code: String) {
                newSubscription(plan_id: $plan_id, coupon_code: $coupon_code) {
                    id
                }
            }`,
            variables: {
                plan_id: this.props.plan.id,
                coupon_code: this.props.couponCode || '',
            }
        })
        .then(res => {
            if (res.errors) {
                this.setState({
                    feedbackText: res.errors[0].debugMessage,
                    feedbackStatus: 'danger',
                    creating: false
                });
            }

            if (res.data.newSubscription && res.data.newSubscription.hasOwnProperty('id')) {
                window.location = `/subscriptions/${res.data.newSubscription.id}`;
            }
        });
    }

    createNewSubscriptionHandler = () => {
        this.setState({
            creating: true,
            feedbackText: ''
        });
        
        if(this.state.toBeCancelledId){
            let query =`mutation CancelSubscriptionById ($id: ID!) {
                cancelSubscriptionById (id: $id) {
                    id
                }
            }`;

            fetch.obj({
                query: query,
                variables: {
                    id: this.state.toBeCancelledId
                }
            })
            .then(res => {
                if (res.hasOwnProperty('errors')) {
                    this.setState({
                        feedbackText: res.errors[0].debugMessage,
                        feedbackStatus: 'danger',
                        creating: false
                    });
                } else {
                    this.createNEwSubscription()
                }



            });
        }else {
            this.createNEwSubscription();
        }

        
    };

    render() {
        const { plan, couponCode } = this.props;

        const content = (
            <React.Fragment>
                <div className="display-4 text-center mb-6 text-danger">Confirmação</div>

                <hr className={this.state.feedbackText && 'mb-2'} />
                {
                    this.state.hasActiveSubscription &&
                    <Alert type={this.state.feedbackColor}>
                        ATENÇÃO, Voce possui uma assinatura ativa vinculada.
                         Ao clicar em CONFIRMAR, você irá CANCELAR a assinatura antiga e
                         aderir a esta nova assinatura.
                    </Alert>
                }
                {
                    this.state.feedbackText &&
                    <Alert type={this.state.feedbackColor}>{this.state.feedbackText}</Alert>
                }

                <div className="row">
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-12">
                                <div className="h3 mb-0">{plan && plan.name}</div>
                                <div>{plan && plan.description}</div>
                                ---
                                <div>
                                    Cobrança recorrente {' '}
                                    {
                                        plan && plan.length === 1 &&
                                        monthName[plan.unit.toLowerCase()]
                                    }
                                    {
                                        plan && plan.length > 1 &&
                                        `a cada ${plan.unit} ${monthName[plan.unit.toLowerCase()]}`
                                    }
                                    , com pagamentos efetuados através de {' '}
                                    <strong>
                                        { plan && plan.paymentMethodCode === 'B' ? 'Boleto' : 'Cartão de Crédito'}
                                    </strong>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-12 text-right">
                                <div className="mb-0">
                                    <span className="lead">
                                        {plan && plan.currency}{' '}
                                        {plan && plan.amount.toFixed(2).replace('.', ',')}

                                        <span className="text-green">(+)</span><br/>

                                        {
                                            plan && this.state.discount > 0 &&
                                            <React.Fragment>
                                                {(this.state.discount).toFixed(2).replace('.', ',')}
                                                <span className="text-red">(-)</span><br/>
                                            </React.Fragment>
                                        }
                                        ------------------------------ <br/>
                                        Subtotal:{' '}
                                        {plan && plan.currency}{' '}
                                        {
                                            plan && this.state.discount > 0 && (plan.amount - this.state.discount).toFixed(2).replace('.', ',')
                                        }
                                        {
                                            plan && this.state.discount < 1 && plan.amount.toFixed(2).replace('.', ',')
                                        }
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {
                    couponCode &&
                    <Alert type="primary" className="mt-5">
                        <strong>Cupom que será aplicado:</strong> {couponCode}{' - '}
                        {
                            this.state.couponObj &&
                            this.state.couponObj.description
                        }
                    </Alert>
                }

                <hr/>

                <div className="text-center">
                    <Button
                        className={"btn " + (this.state.creating ? "btn-success" : "btn-outline-success")}
                        loading={this.state.creating}
                        onClick={this.createNewSubscriptionHandler}
                    >
                        Confirmar
                    </Button>
                    {
                        !this.state.creating &&
                        <button className="btn" onClick={this.closeModal}>cancelar</button>
                    }
                </div>
            </React.Fragment>
        );

        return (
            <div className="selected-plan-modal">
                <Modal
                    onClose={this.modalOnCloseHandler}
                    open={this.state.open}
                    center
                >
                    {plan && content}
                </Modal>
            </div>
        );
    }
}

SelectedPlan.propTypes = propTypes;

export default SelectedPlan;